import Element from '../ui/Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from '../privates/utils/mixin';
import StyleMixin from './mixins/styleMixins/StyleMixin';

/**
 * @class Form
 * @summary A container for the input elements and buttons in a `WixForms` `$w` element.
 * @description
 *  A `Form` element is a useful way to keep elements together. Some actions performed on a form affect the
 *  elements it contains. For example, [hiding](#hide) a form also effectively
 *  hides all the elements in the form, although the values of the
 *  [hidden](#hidden) properties of the elements contained in the form do not change.
 *
 *  A `Form` element is added automatically when you add the [`WixForms`](wix-crm.html#$w-wixforms) 
 *  element to the page. These 2 elements work together to provide the functionality available with the Wix Forms app.
 *
 *  Because they work together, if you hide or collapse either the `WixForms` or the `Form` element, the other element 
 *  is also hidden/collapsed.
 *  
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @tagname Form
 */


/**
 * @member style
 * @label property
 * @summary Gets an object containing information about the styles of the form.
 * @description
 *  The following styles can be used with forms:
 *
 *  + [`backgroundColor`]($w.style.html#backgroundColor)
 *  + [`borderColor`]($w.style.html#borderColor)
 *  + [`borderWidth`]($w.style.html#borderWidth)
 * 
 * 
 * 
 * 
 * 
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Form
 * @override
 */




class Form extends Element {

}

mixin(Form.prototype, HiddenCollapsedMixin.prototype);
mixin(Form.prototype, ClickableMixin.prototype);
mixin(Form.prototype, ContainableMixin.prototype);
mixin(Form.prototype, StyleMixin.prototype);

export default Form;
